import { render, staticRenderFns } from "./InspectproPage.vue?vue&type=template&id=892bca1c"
import script from "./InspectproPage.vue?vue&type=script&lang=js"
export * from "./InspectproPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports